// extracted by mini-css-extract-plugin
module.exports = {"container":"basescreen_container__3nQPt","backgroundTriangle":"basescreen_backgroundTriangle__VofCE","content":"basescreen_content__3JrvW"};